import React from "react";
import { GeoAlt, Globe } from "react-bootstrap-icons";

const GlobalFootprint = () => {
  return (
    <section className="global-section py-5" >
      <div className="container text-center">

        {/* Badge */}
        <div className="d-inline-flex align-items-center gap-2 global-badge px-4 py-2 mb-3">
          <Globe size={18} />
          <span>Global Presence</span>
        </div>

        {/* Heading */}
        <h2 className="fw-bold display-6 mb-3">Our Global Footprint</h2>

        {/* Subtitle */}
        <p className="global-subtitle mx-auto mb-5">
          Strategic international presence enables us to deliver localized insights with global perspective
        </p>

        {/* Cards */}
        <div className="row g-4 justify-content-center">
          {[
            {
              title: "United States",
              desc: "Strategic operations hub",
            },
            {
              title: "India",
              desc: "Technical innovation center",
            },
            {
              title: "Brazil",
              desc: "Emerging market expansion",
            },
          ].map((item, index) => (
            <div key={index} className="col-md-4">
              <div className="footprint-card h-100 text-center p-4">
                <div className="icon-circle mx-auto mb-3">
                  <GeoAlt size={26} />
                </div>
                <h5 className="fw-bold mb-2">{item.title}</h5>
                <p className="mb-0 text-muted">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default GlobalFootprint;
